import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import { WrappedStoryStateProvider } from 'contexts/Wrapped'
import WrappedLoadingState from './WrappedLoadingState'
import WrappedErrorState from './WrappedErrorState'
import WrappedStoryContent from './WrappedStoryContent'
import useWrappedData from '../hooks/useWrappedData'

const FixedModalContainer = styled.div`
  aspect-ratio: 9 / 16;
  width: min(100%, calc(100dvh * 16 / 9));
  max-width: ${rem(560)};
  min-height: ${rem(560)};
  margin: 0 auto;
  overflow: hidden;
`

interface Props {
  uuid?: string
  onClose?: () => void
}

function WrappedStoryDesktop({ uuid, onClose }: Props) {
  const { isLoading, hasError, error, data, state, dispatch, handleRetry } = useWrappedData({ uuid })

  return (
    <ModalBase mode="default" height="auto" size="S" dismissible={false}>
      <ModalBody>
        <FixedModalContainer className="is-full-page">
          {isLoading && <WrappedLoadingState />}
          {hasError && <WrappedErrorState error={error ?? undefined} onRetry={handleRetry} onClose={onClose} />}
          {!isLoading && !hasError && data && (
            <WrappedStoryStateProvider state={state} dispatch={dispatch}>
              <WrappedStoryContent mode="modal" onClose={onClose} />
            </WrappedStoryStateProvider>
          )}
        </FixedModalContainer>
      </ModalBody>
    </ModalBase>
  )
}

export default WrappedStoryDesktop
